var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArmExercise = function SvgArmExercise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.0081C0 23.0081 1.49968 6.1345 5.99872 0L13.4971 1.49988L11.9974 6.1345H8.99808V16.8736H10.4978C13.4971 12.269 19.7058 10.5891 23.455 12.269C28.4039 14.5638 27.954 21.4782 23.455 24.538C19.8558 26.9978 8.99808 29.1426 0 23.0081Z",
    fill: "#E24747"
  })));
};

export default __webpack_public_path__ + "static/media/arm-exercise.ca711423.svg";
export { SvgArmExercise as ReactComponent };